var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgParlour = function SvgParlour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "3rem",
    height: "3rem",
    viewBox: "0 0 60 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 15.315 58.627 1h-11.95l-1.374 14.315h6.09v24.117h-3.404v12.111h9.325v-12.11H53.91V15.314H60zm-4.81-10.53.65 6.745h-6.37l.65-6.745h5.07zm-1.66 42.974h-1.756v-4.542h1.755v4.542z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.024 34.89h-1.508v-4.5a5.688 5.688 0 0 0-5.68-5.68H10.343a5.688 5.688 0 0 0-5.68 5.68v4.501H3.154A3.156 3.156 0 0 0 0 38.045v10.45a3.156 3.156 0 0 0 3.155 3.155h40.869a3.156 3.156 0 0 0 3.155-3.155v-10.45a3.156 3.156 0 0 0-3.155-3.155zm-5.286-4.501v4.501h-3.992v6.203h-9.264V28.5h11.36a1.888 1.888 0 0 1 1.896 1.889zm-30.284 0c0-1.045.85-1.896 1.895-1.896h11.355v12.594h-9.258v-6.203H8.454v-4.495zm34.94 17.47H3.791v-9.184h.878v.007h3.992v6.203h29.87v-6.203h3.992v-.007h.878v9.184h-.007z"
  })))));
};
export default SvgParlour;